<template>
    <div class="home">
      <VIewComponents msg="配置页面"/>
    </div>
  </template>

  <script lang="ts">
  import { defineComponent } from 'vue'
  import VIewComponents from '@/components/ActivityViewComponents.vue' // @ is an alias to /src

  export default defineComponent({
    name: 'configPage',
    components: {
      VIewComponents
    }
  })
  </script>
